export const PAYMENT_METHOD_ORDER = [
  'p2w_us',
  'p2w_europe_revolut_usd',
  'p2w_europe_revolut_eur',
  'p2w_europe_revolut_gbp',
  'wise',
  'p2w_europe_wise_usd',
  'airwallex_dbs_sgp',
  'airwallex',
  'pingpong',
  'crypto',
]

const CRYPTO_ADDRESS_PATTERN = /0x[a-fA-F0-9]{40}/

const COPYABLE_LABELS = new Set([
  'accountnumber',
  'abaroutingnumber',
  'routingnumber',
  'wireroutingnumber',
  'bankaccountnumber',
  'swiftcode',
  'swiftbic',
  'bic',
  'intermediarybic',
  'bankcode',
  'branchcode',
  'iban',
  'usdterc20',
])

function normalizeRequisiteLabel(label) {
  return label.toLowerCase().replace(/[^a-z0-9]/g, '')
}

export function isCopyableRequisiteLabel(label) {
  return COPYABLE_LABELS.has(normalizeRequisiteLabel(label))
}

function getPaymentMethodRank(value) {
  const orderIndex = PAYMENT_METHOD_ORDER.indexOf(value)

  return orderIndex === -1 ? PAYMENT_METHOD_ORDER.length : orderIndex
}

export function sortPaymentMethods(options) {
  return [...options].sort((first, second) => {
    return getPaymentMethodRank(first.value) - getPaymentMethodRank(second.value)
  })
}

export function getPaymentQrValue(paymentType, requisites) {
  if (paymentType !== 'crypto') {
    return ''
  }

  return (requisites || '').match(CRYPTO_ADDRESS_PATTERN)?.[0] ?? ''
}
